import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const DeviceRoutes = defineRoute({
    home: {
        route: {
            path: "/device",
            component: () => loadView(import("./DeviceHome.vue")),
        },
    },
    detail: {
        route: {
            path: "/device/:id",
            component: () => loadView(import("./DeviceDetail.vue")),
        },
        build(id: string) {
            return `/device/${id}`;
        },
    },
});
